
    /// <summary>
    /// 统计内置事件
    /// </summary>
    /// <author>xiexingwu</author>
   export class EventName
    {
        //app界面创建
        static APP_CREATE = "app_create";

        //app界面显示时长（）
        static APP_TIMER = "app_timer";

        //app界面显示统计（）
        static APP_SHOW = "app_show";

        //app界面回流显示统计（），用户离开界面30秒之后，再次回流
        static APP_RESUME = "app_resumed";

        //激活
        static ACTIVE = "active";

        //活跃统计（用户群发送变化时补发的活跃统计事件）
        static ALIVE_AB = "alive_ab";

        //初始化事件
        static ALIVE_INIT = "alive_init";

        //活跃统计
        static ALIVE_RESUME = "alive_resume";

        //活跃统计
        static ALIVE = "alive";

        //Af渠道激活统计
        static ACTIVE_BUY = "active_buy";
    }


    export class RecodeKey
    {
        //产品ID
        static PRODUCT_ID = "product_id";

        //发布的产品ID
        static RELEASE_PRODUCT_ID = "release_product_id";

        //系统：Android
        static OS = "os";

        //	系统版本
        static OS_VERSION = "os_version";

        //basement版本号
        static BSM_VERSION_CODE = "bsm_version_code";

        //basement版本名
        static BSM_VERSION_NAME = "bsm_version_name";

        //	系统语音
        static OS_LANGUAGE = "os_language";

        //	国家
        static COUNTRY = "country";

        //	机型
        static PHONE_MODEL = "phone_model";

        // static USR_ABS = "usr_abs";

        //android_id、UUID
        static UUID_ID = "uuid";

        static PACKAGE_NAME = "package_name";

        //	version_name
        static VERSION_NAME = "version_name";

        //	version_code
        static VERSION_CODE = "version_code";

        //	dpi
        static DPI = "dpi";

        static BSM_TYPE = "bsm_type";
        
        //屏幕分辨率1280×960
        // static SCREEN_WH = "screen_wh";

        //屏幕尺寸
        // static SCREEN_INCHU = "screen_inchu";

        //网络状态
        static NET = "net";

        //vpn状态
        static VPN_USR = "vpn_usr";

        //安装天数
        static INSTALL_DAYS = "install_days";

        //安装小时
        static INSTALL_HOURS = "install_hours";

        //是否为升级用户
        static IS_UPGRADE_USER = "is_upgrade_user";

        //时间
        // static TIME_STAMP = "time_stamp";

        //	统计sdk版本
        static STATICS_SDK_VERSION = "stats_sdk_version";

        static EVENT_DURATION = "event_duration";

        //谷歌广告ID
        static GOOGLE_AID = "google_aid";

        static IFA = "ifa";

        static TP_DEVICE_ID = "tp_device_id";
        //客户端AB测试用户标记
        // static CLIENT_AB = "client_ab";

        //内存总量(MB)
        // static MEMORY = "memory";
        static MEDIA_SOURCE = "media_source";
        static CAMPAIGN = "campaign";
        static ATTR_URL = "attr_url";
        static GOOGLEAID = "googleaid";
        static CONSUME_TIME = "consume_time";
        static ADSET_ADSET_ID = "adset";
        static ADGROUP_NAME = "adgroup";
        static ADGROUP_ID = "abtest";
        static CUSTOM_USER_ID = "custom_user_id";
        static INSTALL_SOURCE = "install_source";
        static ATTRIBUTION_ID = "attribution_id";
        static SDK_CHANNEL_VERSION = "sdk_channel_version";
        static H5_HOST_NAME = "h5_host_name";
    }
